import React from "react";
import { Button, ButtonSize, ButtonVariant, MITheme } from "@spectrumselect/mi-ui-react";
import { FormResolveType } from "../../redux/AppStateSlice";
import { Journey } from "../../redux";
import { local } from "../../internationalization/Localization";
import { S } from "../../auth/sdk";
import "./RegistrationInformationForm.scss";

interface RegistrationInformationFormProps {
  formId?: Journey;
  resolve?: FormResolveType;
  email: string;
  tenant?: string;
}

export const RegistrationInformationForm: React.FunctionComponent<RegistrationInformationFormProps> = (props) => {
  const onContinueButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    props.resolve && props.resolve(S.FormInput.createFormInputSubmissionRequest({}))
  }
  return (
    <div className="RegistrationInformationForm">
      <h1 className="App_pageTitle">
        {props.formId === Journey.WELCOME_USER ?
          local.get("registrationInformationForm.title.welcome") :
          local.get("registrationInformationForm.title.complete")
        }
      </h1>
      <p className="App_formDesc">
        {props.formId === Journey.WELCOME_USER ?
          local.get("registrationInformationForm.description.welcome") :
          local.get("registrationInformationForm.description.complete")
        }
      </p>

      {props.formId === Journey.WELCOME_USER &&
        <div className="RegistrationInformationForm_EmailContainer">
          <span className="RegistrationInformationForm_EmailLabel">
            {local.get("registrationInformationForm.emailLabel")}
          </span>
          <span className="RegistrationInformationForm_Email">{props.email}</span>
        </div>
      }

      <div className="App_formButtonGroup">
        <Button className={`${props.tenant}-btn login100-form-btn`} variant={ButtonVariant.primary} type="submit" onClick={onContinueButtonClick} theme={MITheme.dark} size={ButtonSize.large}>
          {props.formId === Journey.WELCOME_USER ?
            local.get("buttonLabels[2]") :
            local.get("buttonLabels[3]")
          }
        </Button>
      </div>
    </div>
  )
}
